import React from 'react';
import { Link, useHistory } from 'react-router-dom';

const GoBackButton = () => {
    const history = useHistory();
    return (
        <Link
            to="#"
            onClick={() => history.goBack()}
            className="site-button right-arrow button-sm float-right">
            Back
        </Link>
    );
};

export default GoBackButton;